import { Outlet } from 'react-router';

export default function SearchPage() {
  return <Outlet />;
}
